import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import Loader from 'ui-component/Loader';
import { buildLoginRedirectPath } from './authRedirect';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
export default function AuthGuard({ children }) {
  const { isInitialized, isLoggedIn, user } = useAuth();
  const location = useLocation();

  if (!isInitialized) {
    return <Loader />;
  }

  if (!isLoggedIn) {
    return <Navigate to={buildLoginRedirectPath(location.pathname, location.search)} replace />;
  }

  const billingAccessGranted = user?.billing?.access_granted !== false;
  if (!billingAccessGranted && location.pathname !== '/billing') {
    return <Navigate to="/billing" replace />;
  }

  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };
